export const skillsData = [
  'HTML',
  'CSS',
  'Javascript',
  'Bootstrap',
  'React',
  'Flutter',
  'Dart',
  'Mysql',
  'C++',
  'C',
  'Tailwind',
  'MongoDB',
  'Git',
  'Github',
  'Figma',
  'MaterialUI',
  'Canva',
  'Node Js',
  'Express Js',
  'VsCode',
  'Postman',
]